import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons'


const iconExclamationCircle = <FontAwesomeIcon icon={ faExclamationCircle } color="#00a8d5" />

export default function ProductsNotFound({ productDetail }) {
   return (
      <div className="list-item-wrapper products-not-found">
         <div className="list-item">
            <div className="row p-1">
               <div className="col-xs-12">
                  <p>{ iconExclamationCircle }{` Sorry, no ${ productDetail } are available right now.`}</p>
               </div>
            </div>
         </div>
      </div>
   )
}



// WEBPACK FOOTER //
// ./src/components/productsNotFound.js